export async function fetchCandidatePreferences(id) {
  const token = localStorage.getItem("token");
  const rawResponse = await fetch(
    process.env.REACT_APP_API + `/v1/api/getPrefenceList/${id}`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
  );
  const content = await rawResponse.json();
  if (rawResponse.status === 200) {
    return { body: content.body, success: true, message: "" };
  } else {
    return { body: [], success: false, message: content.message };
  }
}

export async function fetchSelectedPreferences(id) {
  const token = localStorage.getItem("token");
  const rawResponse = await fetch(
    process.env.REACT_APP_API + `/v1/api/fetch-candidate-preference/${id}`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
  );
  const content = await rawResponse.json();
  if (rawResponse.status === 200) {
    return { body: content.body, success: true, message: "" };
  } else {
    return { body: [], success: false, message: content.message };
  }
}

export async function submitPreferences(formData, id) {
  const token = localStorage.getItem("token");
  const url = `${process.env.REACT_APP_API}/v1/api/submit-prefernces/${id}`;
  const rawResponse = await fetch(url, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(formData),
  });

  try {
    const content = await rawResponse.json();
    if (rawResponse.ok) {
      return { body: content.body, success: true, message: "" };
    } else {
      return { body: [], success: false, message: content.message };
    }
  } catch (error) {
    console.error("Error parsing JSON:", error);
    return {
      body: [],
      success: false,
      message: "Unexpected response from server",
    };
  }
}

export async function verifyAllUploadedFiles(id) {
  const token = localStorage.getItem("token");
  const url = `${process.env.REACT_APP_API}/v1/api/verify-all-uploaded-files/${id}`;
  const rawResponse = await fetch(url, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: null,
  });

  try {
    const content = await rawResponse.json();
    if (rawResponse.ok) {
      return { body: content.body, success: true, message: "" };
    } else {
      return { body: [], success: false, message: content.message };
    }
  } catch (error) {
    console.error("Error parsing JSON:", error);
    return {
      body: [],
      success: false,
      message: "Unexpected response from server",
    };
  }
}
